import {useCompany} from '@/shared/contexts/UserContext/useUserContext';

export default function useImageMaxFileSize(): number | undefined {
  const company = useCompany();

  if (company.isForClinicalTrials) {
    const envValue = import.meta.env.VITE_CUSTOM_IMAGE_MAX_FILE_SIZE;

    if (envValue) {
      const parsedValue = Number(envValue);
      if (parsedValue > 0) {
        return parsedValue;
      }
    }
  }

  return undefined;
}
